import { render, staticRenderFns } from "./SellerVerifyRequest.vue?vue&type=template&id=4f8607a6&scoped=true&"
import script from "./SellerVerifyRequest.vue?vue&type=script&lang=js&"
export * from "./SellerVerifyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8607a6",
  null
  
)

export default component.exports